export default __webpack_public_path__ + "static/media/afterparty-logotype.a0a45050.png";